import React, { useState, useEffect } from "react";
import { notification, message } from "antd";

import {
  Dropdown,
  Layout,
  Menu,
  Avatar,
  Row,
  Col,
  Space,
  Carousel,
  Input,
  Button,
  Form,
  Select,
  AutoComplete,
} from "antd";
import {
  LaptopOutlined,
  NotificationOutlined,
  UserOutlined,
  LoginOutlined,
  SearchOutlined,
  FilterOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import "./header.css";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useResolvedPath,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getCountry,
  setCountryName,
} from "../../../store/actions/homepageActions";
// import Input from "antd/lib/input/Input";
const { Option } = Select;
const contentStyle = {
  height: "160px",
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  background: "grey",
};

const { Header } = Layout;
const Headers = () => {
  const MENU = (
    <Menu className="header-menu">
      <Menu.Item key="1">
        <h4>
          <strong>Guest</strong>
        </h4>
      </Menu.Item>
      <Menu.Item key="2">
        <LoginOutlined />
      </Menu.Item>
    </Menu>
  );
  const [search, setSearch] = useState();
  const navigate = useNavigate();
  const [country, setCountry] = useState(
    localStorage.getItem("Country") !== undefined
      ? localStorage.getItem("Country")
      : "USA"
  );
  const dispatch = useDispatch();
  useEffect(() => {
    //setCountry(localStorage.getItem("Country"));
    return () => {};
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("Country") === undefined ||
      localStorage.getItem("Country") === null
    ) {
      dispatch(getCountry());
    } //else {
    //   setCountryName(localStorage.getItem("Country"));
    // }
  }, []);

  const openNotification = () => {
    notification.open({
      message: "Notification Title",
      description:
        "This is the content of the notification. This is the content of the notification. This is the content of the notification.",
      onClick: () => {},
    });
  };
  const handleSelect = (e) => {
    localStorage.setItem("Country", e);
    navigate("/");
    // openNotification();
    // setTimeout(() => {
    //   message.success("Country change successfully");
    // }, 2000);
    window.location.reload();
    dispatch(setCountryName(e));
  };

  const options = [
    // { label: "One", value: "One" },
    // { label: "Two", value: "Two" },
    // { label: "Three", value: "Three" },
    // { label: "Four", value: "Four" },
    // { label: "Five", value: "Five" },
  ];

  const handleSearch = (e) => {
    if (search) {
    }
  };

  const searchText = (
    <Form.Item>
      <AutoComplete
        name="search"
        onChange={(val) => setSearch(val)}
        onSelect={(val) => setSearch(val)}
        dataSource={options}
        value={search}
        filterOption={(inputValue, option) =>
          option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
      >
        <Input
          name="search"
          suffix={<SearchOutlined />}
          placeholder="Search Products, category, top rated products etc"
        ></Input>
      </AutoComplete>
      <Button type="primary" onClick={() => handleSearch()}>
        <SearchOutlined /> Search
      </Button>
    </Form.Item>
  );

  const items = ["ECRON HUB ", searchText];

  return (
    <>
      {/* <Header>
        <div className="logo" />
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={["2"]}
          items={items}
        />
      </Header> */}
      <Header className="main-header">
        <Row>
          <Col span={4} order={1}>
            <Link to="/">
              <strong> ECRON HUB </strong>
            </Link>
          </Col>

          <Col span={7} order={3} style={{ marginTop: 16.5 }}>
            <Form.Item>
              <AutoComplete
                name="search"
                onChange={(val) => setSearch(val)}
                onSelect={(val) => setSearch(val)}
                dataSource={options}
                value={search}
                filterOption={(inputValue, option) =>
                  option.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
              >
                <Input
                  name="search"
                  suffix={<SearchOutlined />}
                  placeholder="Search Products, category, top rated products etc"
                ></Input>
              </AutoComplete>
            </Form.Item>
          </Col>
          <Col span={2} order={3}>
            <Button type="primary" onClick={() => handleSearch()}>
              <SearchOutlined /> Search
            </Button>
          </Col>

          <Col span={6} order={3} style={{ marginTop: 15, padding: 2 }}>
            <Form.Item
              //label={<div style={{ color: "white" }}>Select Country</div>}
              name="country"
              value={country}
            >
              <Select
                placeholder="Country"
                defaultValue={country}
                onSelect={(e) => handleSelect(e)}
              >
                <Option value="usa">Country-USA</Option>
                <Option value="india">Country-India</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={3} order={4} style={{ marginLeft: 2 }}>
            <Avatar icon={<UserOutlined />} />
          </Col>
        </Row>
      </Header>
      <Row style={{ textAlign: "center" }}>
        <Col span={24}>
          <Menu
            mode="horizontal"
            //className="header-bar"
            theme="dark"
            style={{ alignContent: "center" }}
          >
            <Menu.Item key="1" className="page-select">
              <NavLink to="/electronics">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                <strong>Electronics</strong>
              </NavLink>
            </Menu.Item>
            <Menu.Item key="2">
              <NavLink to="/projectors">
                <strong>Projectors </strong>
              </NavLink>
            </Menu.Item>
            <Menu.Item key="3">
              <NavLink to="/oled-tv">
                <strong>OLED TVs</strong>
              </NavLink>
            </Menu.Item>
            <Menu.Item key="4">
              <NavLink to="/appliances">
                <strong>HOME APPLIANCES</strong>
              </NavLink>
            </Menu.Item>
            <Menu.Item key="5">
              <NavLink to="/car-accessories">
                <strong>CAR ACCESSSORIES</strong>
              </NavLink>
            </Menu.Item>
          </Menu>
        </Col>
      </Row>
      {false && (
        <Row gutter={[16, 16]} justify="center">
          <Col>
            <Carousel autoplay>
              <div>
                <Row justify="center">
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                </Row>
                {/* <h3 style={contentStyle}>
                  {" "}
                  <img
                    src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                    alt="data.title"
                    width="350px"
                    height="150px"
                  />
                </h3> */}
              </div>
              <div>
                <Row justify="center">
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                </Row>
              </div>
              <div>
                <Row justify="center">
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                </Row>{" "}
              </div>
              <div>
                <Row justify="center">
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                  <Col>
                    {" "}
                    <img
                      src="https://m.media-amazon.com/images/I/61GwJAhftvS._SL1500_.jpg"
                      alt="data.title"
                      width="350px"
                      height="150px"
                    />
                  </Col>
                </Row>
              </div>
            </Carousel>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Headers;
